export class AppConfig {

	static DB_VERSION: number = 1;
	static DB_NAME: string = "fitosaas";
	static TIMEOUT: number = 60000;
}